@if (label()) {
    <p-floatlabel [variant]="labelVariant()">
        <ng-container [ngTemplateOutlet]="control" />
        <label [attr.for]="inputId()">
            {{ label() }}
            @if (required()) {
                <span>*</span>
            }
            @if (info(); as content) {
                <kno2-info-popover
                    class="ml-1 align-middle"
                    [title]="infoTitle()"
                    [content]="content" />
            }
        </label>
    </p-floatlabel>
} @else {
    <ng-container [ngTemplateOutlet]="control" />
}
<ng-template #control>
    @if (icon(); as iconClass) {
        <p-iconfield iconPosition="right">
            <ng-container [ngTemplateOutlet]="inputEl" />
            <p-inputicon
                [class.cursor-pointer]="!!iconAction()"
                [attr.role]="iconAction() ? 'button' : null"
                [attr.tabindex]="iconAction() ? 0 : null"
                [attr.aria-label]="iconAction() ? iconLabel() : null"
                (click)="onIconClick()"
                (keydown)="onIconKeydown($event)">
                <i
                    [class]="iconClass"
                    aria-hidden="true"></i>
            </p-inputicon>
        </p-iconfield>
    } @else {
        <ng-container [ngTemplateOutlet]="inputEl" />
    }
</ng-template>
<ng-template #inputEl>
    <input
        pInputText
        [pInputMask]="mask() ?? ''"
        [type]="type()"
        [placeholder]="placeholder() ?? ''"
        [id]="inputId()"
        [invalid]="showInvalid()"
        [attr.readonly]="isReadonly() ? '' : null"
        [pSize]="size()"
        [maxlength]="maxlength()"
        [pattern]="pattern()"
        [disabled]="disabled()"
        [attr.disabled]="disabled() ? '' : null"
        [style]="fullWidthStyle"
        [ngModel]="displayedValue()"
        (ngModelChange)="handleChange($event)"
        (blur)="markTouched()"
        [ngModelOptions]="standaloneNgModel" />
</ng-template>
@if (showError() && errorMessage(); as message) {
    <small class="kno2-form-control">{{ message }}</small>
}
